import { saveFile } from "../../../utils/FileSaver";
import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/Agreements";

export const getAgreements = async () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res.data;
  });
};

export const getAllAgreements = async () => {
  return axios.get(`${api_base_url}/AllAgreements`).then((res) => {
    return res.data;
  });
};

export const searchAgreements = async (data) => {
  const res = await axios.post(`${api_base_url}/SearchAgreements`, data, {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};
export const getAgreementsCount = async () => {
  return axios.get(`${api_base_url}/AgreementCounts`);
};
export const getAgreementsByIDs = async ({ queryKey }) => {
  const [_key, filters] = queryKey;
  //Recontruct filter parameter as Query String for GET Method [FromQuery]
  var queryStrings = new URLSearchParams();
  if (filters) {
    if (filters.IsFranchise === true || filters.IsFranchise === false) {
      queryStrings.append("IsFranchise", filters.IsFranchise);
    }
    if (
      filters.AgreementIsActive === true ||
      filters.AgreementIsActive === false
    ) {
      queryStrings.append("AgreementIsActive", filters.AgreementIsActive);
    }
    if (
      filters.agreementIsActive === true ||
      filters.agreementIsActive === false
    ) {
      queryStrings.append("AgreementIsActive", filters.agreementIsActive);
    }
    if (
      filters.isWritingNewBusiness === true ||
      filters.isWritingNewBusiness === false
    ) {
      queryStrings.append("IsWritingNewBusiness", filters.isWritingNewBusiness);
    }

    filters.CarrierId &&
      filters.CarrierId.map((x) => queryStrings.append("carrierId", x));
    filters.AgreementRepositoryId &&
      filters.AgreementRepositoryId.map((x) =>
        queryStrings.append(`AgreementRepositoryID`, parseInt(x))
      );
    filters.State?.map((x) => queryStrings.append("State", x));
    filters.Agency && queryStrings.append("Agency", filters.Agency);
    filters.AgencyList?.map((x) => queryStrings.append("agencyList", x));
    filters.EntityList?.map((x) => queryStrings.append("entityList", x));
    filters.EntityID && queryStrings.append("EntityID", filters.EntityID);
    filters.Commission && queryStrings.append("Commission", filters.Commission);
    filters.PolicyType?.map((x) => queryStrings.append("PolicyType", x));
    filters.EffectiveDateTo &&
      queryStrings.append("EffectiveDateTo", filters.EffectiveDateTo);
    filters.EffectiveDateFrom &&
      queryStrings.append("EffectiveDateFrom", filters.EffectiveDateFrom);
    filters.ExpirationDate &&
      queryStrings.append("ExpirationDate", filters.ExpirationDate);
    filters.SalesLead && queryStrings.append("SalesLead", filters.SalesLead);
    filters.Billing && queryStrings.append("Billing", filters.Billing);
    filters.masterLegalEntityId &&
      queryStrings.append("masterLegalEntityId", filters.masterLegalEntityId);
  }
  var filterParams = {
    params: queryStrings,
  };

  return await axios
    .get(`${api_base_url}/GetAgreementsByIDs`, filterParams)
    .then((res) => {
      if (res) {
        return res.data;
      }
    });
};
export const searchGroupAgreements = async (data) => {
  const res = await axios.post(`${api_base_url}/SearchGroupAgreements`, data, {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};
export const postAgreement = async (data) => {
  const formData = new FormData();

  formData.append("carrier", data.carrier);
  formData.append("masterCarrierId", data.masterCarrierId);
  formData.append("isRenewal", data.isRenewal);
  formData.append("isConflictingAgreement", data.isConflictingAgreement);
  data.program && formData.append("program", data.program);
  data.standard && formData.append("standard", data.standard);
  data.agency && formData.append("agency", data.agency);
  data.agencyMappingId &&
    formData.append("agencyMappingId", data.agencyMappingId);
  data.entityName && formData.append("entityName", data.entityName);
  data.entityId && formData.append("entityId", data.entityId);
  data.state && formData.append("state", data.state);
  data.effectiveDate && formData.append("effectiveDate", data.effectiveDate);
  data.expirationDate && formData.append("expirationDate", data.expirationDate);
  data.commissionEffectiveDate &&
    formData.append("commissionEffectiveDate", data.commissionEffectiveDate);
  data.commissionExpirationDate &&
    formData.append("commissionExpirationDate", data.commissionExpirationDate);
  data.paidType && formData.append("paidType", data.paidType);
  data.policyType && formData.append("policyType", data.policyType);
  data.policyPrefix && formData.append("policyPrefix", data.policyPrefix);
  data.newPercentage && formData.append("newPercentage", data.newPercentage);
  data.renewalPercentage &&
    formData.append("renewalPercentage", data.renewalPercentage);
  data.newPercentageConfie &&
    formData.append("newPercentageConfie", data.newPercentageConfie);
  data.newPercentageFranchise &&
    formData.append("newPercentageFranchise", data.newPercentageFranchise);
  data.renewPercentageConfie &&
    formData.append("renewPercentageConfie", data.renewPercentageConfie);
  data.renewPercentageFranchise &&
    formData.append("renewPercentageFranchise", data.renewPercentageFranchise);
  formData.append("isActive", data.isActive);
  formData.append("AgreementIsActive", data.agreementIsActive);
  data.notes && formData.append("notes", data.notes);
  data.licensedTypeId && formData.append("licensedTypeId", data.licensedTypeId);
  data.planCode && data.planCode && formData.append("planCode", data.planCode);
  data.producerCode && formData.append("producerCode", data.producerCode);
  data.agreementType && formData.append("agreementType", data.agreementType);
  data.billing && formData.append("billing", data.billing);
  data.newBusinessPhysicalDamageRate &&
    formData.append(
      "newBusinessPhysicalDamageRate",
      data.newBusinessPhysicalDamageRate
    );
  data.renewalLiabilityRate &&
    formData.append("renewalLiabilityRate", data.renewalLiabilityRate);
  data.newBusinessLiabilityRate &&
    formData.append("newBusinessLiabilityRate", data.newBusinessLiabilityRate);
  data.renewalPhysicalDamageRate &&
    formData.append(
      "renewalPhysicalDamageRate",
      data.renewalPhysicalDamageRate
    );
  data.isSplitRate && formData.append("isSplitRate", data.isSplitRate);
  data.otherCommissionPercentageList &&
    data.otherCommissionPercentageList.map((x) =>
      formData.append("otherCommissionPercentageList", x)
    );
  data.otherCommissionPercentageTransactionList &&
    data.otherCommissionPercentageTransactionList.map((x) =>
      formData.append("otherCommissionPercentageTransactionList", x)
    );
  data.pifMinList &&
    data.pifMinList.map((x) => formData.append("PIFMinList", x));
  data.pifMaxList &&
    data.pifMaxList.map((x) => formData.append("PIFMaxList", x));

  data.contingentCommission &&
    formData.append("contingentCommission", data.contingentCommission);
  data.salesLead && formData.append("salesLead", data.salesLead);
  data.frequencyOfCommissionPaymentsId &&
    formData.append(
      "frequencyOfCommissionPaymentsId",
      data.frequencyOfCommissionPaymentsId
    );
  data.paymentRemittanceTypeId &&
    formData.append("paymentRemittanceTypeId", data.paymentRemittanceTypeId);
  data.recordId && formData.append("recordId", data.recordId);
  data.isFranchise && formData.append("IsFranchise", data.isFranchise);
  data.sourceFiles &&
    Object.entries(data.sourceFiles).forEach(([key, value]) => {
      formData.append(`sourceFiles.${key}`, value);
    });

  data.attachments && formData.append("attachments", data.attachments);
  data.lineOfBusinessId &&
    formData.append("lineOfBusinessId", data.lineOfBusinessId);
  data.businessTypeId && formData.append("businessTypeId", data.businessTypeId);
  data.riskTypeId && formData.append("riskType", data.riskTypeId);
  data.sourceFileId && formData.append("sourceFileId", data.sourceFileId);
  data.flatRatePerPolicy &&
    formData.append("flatRatePerPolicy", data.flatRatePerPolicy);
  data.newBusinessFlatRate &&
    formData.append("newBusinessFlatRate", data.newBusinessFlatRate);

  data.renewalFlatRate &&
    formData.append("renewalFlatRate", data.renewalFlatRate);
  data.commissionRemittanceId &&
    formData.append("commissionRemittanceId", data.commissionRemittanceId);
  data.slidingScales &&
    formData.append("slidingScales", JSON.stringify(data.slidingScales));
  data.isSlidingScale && formData.append("isSlidingScale", data.isSlidingScale);
  data.masterLegalEntityId &&
    formData.append("masterLegalEntityId", data.masterLegalEntityId);
  data.isWritingNewBusiness &&
    formData.append("isWritingNewBusiness", data.isWritingNewBusiness);
  data.overridePaymentTypeId &&
    formData.append("overridePaymentTypeId", data.overridePaymentTypeId);
  data.overridePercentage &&
    formData.append("overridePercentage", data.overridePercentage);
  data.overrideRenewalPercentage &&
    formData.append(
      "overrideRenewalPercentage",
      data.overrideRenewalPercentage
    );
  data.isOverridePayment &&
    formData.append("isOverridePayment", data.isOverridePayment);

  return axios.post(`${api_base_url}/`, formData);
};
export const addRenewedAgreements = async (renewedData) => {
  renewedData.slidingScales = JSON.stringify(renewedData.slidingScale);
  return await axios.post(`${api_base_url}/AddRenewedAgreements`, renewedData);
};
export const updateAgreement = (data) => {
  const formData = new FormData();
  formData.append("agreementRepositoryId", data.agreementRepositoryId);
  data.oldAgreementRepositoryId &&
    formData.append("oldAgreementRepositoryId", data.oldAgreementRepositoryId);
  formData.append("carrier", data.carrier);
  formData.append("isConflictingAgreement", data.isConflictingAgreement);
  formData.append("masterCarrierId", data.masterCarrierId);
  formData.append("isRenewal", data.isRenewal);
  data.newBusinessPhysicalDamageRate &&
    formData.append(
      "newBusinessPhysicalDamageRate",
      data.newBusinessPhysicalDamageRate
    );
  data.renewalLiabilityRate &&
    formData.append("renewalLiabilityRate", data.renewalLiabilityRate);
  data.newBusinessLiabilityRate &&
    formData.append("newBusinessLiabilityRate", data.newBusinessLiabilityRate);
  data.renewalPhysicalDamageRate &&
    formData.append(
      "renewalPhysicalDamageRate",
      data.renewalPhysicalDamageRate
    );
  data.isSplitRate && formData.append("isSplitRate", data.isSplitRate);
  data.program && formData.append("program", data.program);
  data.standard && formData.append("standard", data.standard);
  data.agency && formData.append("agency", data.agency);
  data.agencyMappingId &&
    formData.append("agencyMappingId", data.agencyMappingId);
  data.entityName && formData.append("entityName", data.entityName);
  data.entityId && formData.append("entityId", data.entityId);
  data.state && formData.append("state", data.state);
  data.effectiveDate && formData.append("effectiveDate", data.effectiveDate);
  data.expirationDate && formData.append("expirationDate", data.expirationDate);
  data.commissionEffectiveDate &&
    formData.append("commissionEffectiveDate", data.commissionEffectiveDate);
  data.commissionExpirationDate &&
    formData.append("commissionExpirationDate", data.commissionExpirationDate);
  data.paidType && formData.append("paidType", data.paidType);
  data.policyType && formData.append("policyType", data.policyType);
  data.policyPrefix && formData.append("policyPrefix", data.policyPrefix);
  data.newPercentage && formData.append("newPercentage", data.newPercentage);
  data.renewalPercentage &&
    formData.append("renewalPercentage", data.renewalPercentage);
  data.newPercentageConfie &&
    formData.append("newPercentageConfie", data.newPercentageConfie);
  data.newPercentageFranchise &&
    formData.append("newPercentageFranchise", data.newPercentageFranchise);
  data.renewPercentageConfie &&
    formData.append("renewPercentageConfie", data.renewPercentageConfie);
  data.renewPercentageFranchise &&
    formData.append("renewPercentageFranchise", data.renewPercentageFranchise);
  formData.append("isActive", data.isActive);
  formData.append("AgreementIsActive", data.agreementIsActive);
  data.notes && formData.append("notes", data.notes);
  data.licensedTypeId && formData.append("licensedTypeId", data.licensedTypeId);
  data.planCode && data.planCode && formData.append("planCode", data.planCode);
  data.producerCode && formData.append("producerCode", data.producerCode);
  data.agreementType && formData.append("agreementType", data.agreementType);
  data.billing && formData.append("billing", data.billing);
  data.slidingScales &&
    formData.append("slidingScales", JSON.stringify(data.slidingScales));
  data.isSlidingScale && formData.append("isSlidingScale", data.isSlidingScale);
  data.otherCommissionPercentageList &&
    data.otherCommissionPercentageList.map((x) =>
      formData.append("otherCommissionPercentageList", x)
    );
  data.otherCommissionPercentageTransactionList &&
    data.otherCommissionPercentageTransactionList.map((x) =>
      formData.append("otherCommissionPercentageTransactionList", x)
    );
  data.pifMinList &&
    data.pifMinList.map((x) => formData.append("PIFMinList", x));
  data.pifMaxList &&
    data.pifMaxList.map((x) => formData.append("PIFMaxList", x));

  data.contingentCommission &&
    formData.append("contingentCommission", data.contingentCommission);
  data.salesLead && formData.append("salesLead", data.salesLead);
  data.frequencyOfCommissionPaymentsId &&
    formData.append(
      "frequencyOfCommissionPaymentsId",
      data.frequencyOfCommissionPaymentsId
    );
  data.paymentRemittanceTypeId &&
    formData.append("paymentRemittanceTypeId", data.paymentRemittanceTypeId);
  data.recordId && formData.append("recordId", data.recordId);
  data.isFranchise && formData.append("IsFranchise", data.isFranchise);
  data.sourceFiles &&
    Object.entries(data.sourceFiles).forEach(([key, value]) => {
      formData.append(`sourceFiles.${key}`, value);
    });

  data.attachments && formData.append("attachments", data.attachments);
  data.lineOfBusinessId &&
    formData.append("lineOfBusinessId", data.lineOfBusinessId);
  data.businessTypeId && formData.append("businessTypeId", data.businessTypeId);
  data.riskTypeId && formData.append("riskType", data.riskTypeId);
  data.sourceFileId && formData.append("sourceFileId", data.sourceFileId);
  data.flatRatePerPolicy &&
    formData.append("flatRatePerPolicy", data.flatRatePerPolicy);
  data.newBusinessFlatRate &&
    formData.append("newBusinessFlatRate", data.newBusinessFlatRate);
  data.renewalFlatRate &&
    formData.append("renewalFlatRate", data.renewalFlatRate);
  data.commissionRemittanceId &&
    formData.append("commissionRemittanceId", data.commissionRemittanceId);
  data.masterLegalEntityId &&
    formData.append("masterLegalEntityId", data.masterLegalEntityId);
  data.isWritingNewBusiness &&
    formData.append("isWritingNewBusiness", data.isWritingNewBusiness);
  data.overridePaymentTypeId &&
    formData.append("overridePaymentTypeId", data.overridePaymentTypeId);
  data.overridePercentage &&
    formData.append("overridePercentage", data.overridePercentage);
  data.overrideRenewalPercentage &&
    formData.append(
      "overrideRenewalPercentage",
      data.overrideRenewalPercentage
    );
  data.isOverridePayment &&
    formData.append("isOverridePayment", data.isOverridePayment);

  return axios.put(`${api_base_url}/`, formData);
};
export const updateMainAgreement = async (updatedMainData) => {
  const formData = new FormData();
  formData.append("carrier", updatedMainData.carrier);
  formData.append(
    "isConflictingAgreement",
    updatedMainData.isConflictingAgreement
  );
  updatedMainData.effectiveDate &&
    formData.append("effectiveDate", updatedMainData.effectiveDate);
  updatedMainData.expirationDate &&
    formData.append("expirationDate", updatedMainData.expirationDate);
  formData.append("masterCarrierId", updatedMainData.masterCarrierId);
  formData.append("newPercentage", updatedMainData.newPercentage);
  formData.append("newPercentageConfie", updatedMainData.newPercentageConfie);
  formData.append(
    "newPercentageFranchise",
    updatedMainData.newPercentageFranchise
  );
  formData.append(
    "renewPercentageConfie",
    updatedMainData.renewPercentageConfie
  );
  formData.append(
    "renewPercentageFranchise",
    updatedMainData.renewPercentageFranchise
  );
  formData.append("renewalPercentage", updatedMainData.renewalPercentage);
  updatedMainData.agreementRepositoryId.map((x) =>
    formData.append("agreementRepositoryId", x)
  );
  updatedMainData.attachments &&
    formData.append("attachments", updatedMainData.attachments);
  updatedMainData.attachmentsForDelete &&
    updatedMainData.attachmentsForDelete?.forEach((obj, i) =>
      Object.entries(obj).forEach(([key, value]) => {
        formData.append(`attachmentsForDelete[${i}].${key}`, value);
      })
    );
  updatedMainData.sourceFileId &&
    formData.append("sourceFileId", updatedMainData.sourceFileId);
  updatedMainData.flatRatePerPolicy &&
    formData.append("flatRatePerPolicy", updatedMainData.flatRatePerPolicy);
  updatedMainData.newBusinessFlatRate &&
    formData.append("newBusinessFlatRate", updatedMainData.newBusinessFlatRate);
  updatedMainData.renewalFlatRate &&
    formData.append("renewalFlatRate", updatedMainData.renewalFlatRate);
  updatedMainData.newBusinessPhysicalDamageRate &&
    formData.append(
      "newBusinessPhysicalDamageRate",
      updatedMainData.newBusinessPhysicalDamageRate
    );
  updatedMainData.renewalLiabilityRate &&
    formData.append(
      "renewalLiabilityRate",
      updatedMainData.renewalLiabilityRate
    );
  updatedMainData.newBusinessLiabilityRate &&
    formData.append(
      "newBusinessLiabilityRate",
      updatedMainData.newBusinessLiabilityRate
    );
  updatedMainData.renewalPhysicalDamageRate &&
    formData.append(
      "renewalPhysicalDamageRate",
      updatedMainData.renewalPhysicalDamageRate
    );
  updatedMainData.isSplitRate &&
    formData.append("isSplitRate", updatedMainData.isSplitRate);
  updatedMainData.slidingScales &&
    formData.append(
      "slidingScales",
      JSON.stringify(updatedMainData.slidingScales)
    );
  updatedMainData.isSlidingScale &&
    formData.append("isSlidingScale", updatedMainData.isSlidingScale);

  return await axios.put(`${api_base_url}/UpdateMainRow`, formData);
};
//multi detelete
export const deleteAgreements = async (agreementIds, userName) => {
  return await axios.delete(`${api_base_url}/${userName}`, {
    data: agreementIds,
  });
};
export const uploadAgreement = async ([file, isFranchiseUpload]) => {
  var data = await axios.post(`${api_base_url}/upload`, file, {
    params: { isFranchise: isFranchiseUpload },
    headers: { "Content-Type": "multipart/form-data" },
  });

  return data;
};
export const downloadAgreement = async (data) => {
  var response = await axios.post(`${api_base_url}/download`, data, {
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
  });
  return response;
};
export const downloadAgreementTemplate = async (isFranchise) => {
  var response = await axios.get(`${api_base_url}/download/template/`, {
    params: { isFranchise: isFranchise },
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
  });
  return response;
};
export const validateMassAgreementData = async (updatedAgreement) => {
  var { data } = await axios.post(`${api_base_url}/validate`, updatedAgreement);
  return data;
};
export const uploadValidMassAgreementData = async (validData) => {
  return await axios.post(`${api_base_url}/massupload`, validData);
};
export const getFile = (id, agreement) => {
  return axios
    .post(`${api_base_url}/file/${id}`, agreement, { responseType: "blob" })
    .then((res) => {
      const url = URL.createObjectURL(res.data);
      const filename = agreement.sourceFiles.filter(
        (s) => s.sourceFileId === id
      )[0].sourceLink;

      saveFile(url, filename);
    });
};
//Export agreement data
export const exportAgreements = async (agreementsData) => {
  var response = await axios.post(
    `${api_base_url}/ExportExcel`,
    agreementsData,
    {
      headers: { "Content-Type": "application/json" },
      responseType: "blob",
    }
  );
  return response;
};
export const getAgencyFromAgencyMapping = () => {
  return axios.get(`${api_base_url}/AgencyFromAgencyMapping`).then((res) => {
    return res.data;
  });
};
export const downloadAgreementsById = (forDownloadIds) => {
  return axios
    .post(`${api_base_url}/GetAgmtsForDownload`, forDownloadIds)
    .then((res) => res.data);
};

export const getDeactivatedAgreementsCount = async () => {
  return axios.get(`${api_base_url}/DeactivatedAgreementCount`).then((res) => {
    return res.data;
  });
};
export const getConfieAgreementsCount = async () => {
  return axios.get(`${api_base_url}/ConfieAgreementCount`).then((res) => {
    return res.data;
  });
};
export const getFranchiseAgreementsCount = async () => {
  return axios.get(`${api_base_url}/FranchiseAgreementCount`).then((res) => {
    return res.data;
  });
};

export const getAllAgreementsCount = async () => {
  return axios.get(`${api_base_url}/AllAgreementsCount`).then((res) => {
    return res.data;
  });
};

export const getActiveAgreementsCount = async () => {
  return axios.get(`${api_base_url}/ActiveAgreementCount`).then((res) => {
    return res.data;
  });
};

export const getCommisionOfPayments = async () => {
  const data = await axios.get(`${api_base_url}/CommisionOfPayments`);
  return data;
};

export const getAgmtPaymtRemittanceType = async () => {
  const data = await axios.get(
    `${api_base_url}/AgreementPaymentRemittanceType`
  );
  return data;
};

export const getAllAgreementCount = async () => {
  return await axios.get(`${api_base_url}/AllAgreementsCount`).then((res) => {
    return res.data;
  });
};

export const getAllMasterLegalEntity = async () => {
  return await axios.get(`${api_base_url}/GetMasterLegalEntity`).then((res) => {
    return res.data;
  });
};

export const getAllOverridePaymentType = async () => {
  return await axios
    .get(`${api_base_url}/GetOverridePaymentType`)
    .then((res) => {
      return res.data;
    });
};
